import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { GetEanSearch } from './Componnents/Ean_search';

export interface OrdersListModel {
  date_purchased;
  orders_id;
  mol_auftrag_id;
}

interface OrdersListProp {
  data: {
    orders: {
      orders: OrdersListModel[];
      eanInfo?: any;
    };
  };
}

export default class OrderList extends React.Component<OrdersListProp> {
  render(): React.ReactNode {
    let orders = this.props.data.orders.orders ?? [];

    let GetEanSearch_local = GetEanSearch(
      '/konto/mol_orders',
      this.props.data.orders.eanInfo,
    );
    let GetEanSearch_local_gui = GetEanSearch_local.gui;
    let eanSearchParam = GetEanSearch_local.eanSearchParam;

    return (
      <div id="OrdersList">
        {GetEanSearch_local_gui}
        <table>
          <thead>
            <tr>
              <th>Datum</th>
              <th>Auftrag ID</th>
              <th>Bestellung ID</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((item, index) => {
              let key = 'data_' + index;
              let classNameRow = 'row' + (index % 2 == 1 ? ' mod2' : '');
              let itemLink = '/konto/mol_orders/' + item.mol_auftrag_id;
              if (eanSearchParam != '') {
                itemLink += '?' + eanSearchParam;
              }

              const dateObject = new Date(item.date_purchased);

              // Datum umformatieren
              const formattedDate_purchased = dateObject.toLocaleDateString(
                'de-DE',
                {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                },
              );

              return (
                <tr id={key} key={key} className={classNameRow}>
                  <td>{formattedDate_purchased}</td>
                  <td>
                    <MolLink to={itemLink} href={itemLink}>
                      {item.mol_auftrag_id}
                    </MolLink>
                  </td>
                  <td>{item.orders_id}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
